var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-footer',{attrs:{"fixed":true,"app":""}},[_c('span',[_vm._v("Learn")]),_c('span',{staticClass:"font-weight-light"},[_vm._v("App ©")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }